import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPromptText = memo((props: PropsWithChildren) => {
  return (
    <BodyText sizeMatch={['22']} style={styles.text}>
      {props.children}
    </BodyText>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.CREAM,
    marginBottom: theme.spacing['6'],
  },
});
